export default __webpack_public_path__ + "resources/icons/d241-3a72.png";